"use strict";
//@ts-check
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.np = void 0;
/**
 * Parser and main namespace for the ndarray-js package.
 * <script src="https://cdn.jsdelivr.net/npm/ndarray-js@latest/dist/index.js"></script>
 */
var np = function (template) {
    var _a;
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    var usage = 'Usage example: np`np.arange(10)+${5}` or np([0,1,2]).';
    if (typeof template == "number")
        return template;
    if (template instanceof np.NDArray)
        return template;
    if (!Array.isArray(template))
        throw new Error("Expected template or array. ".concat(usage));
    if (!template.length)
        throw new Error("Expected argument. ".concat(usage));
    if (typeof template[0] == "string") {
        if (variables.length + 1 != template.length)
            throw new Error("Wrong input. ".concat(usage));
        //@ts-ignore
        return (_a = np.modules.grammar).parse.apply(_a, __spreadArray([/**@type {*}*/ (template)], __read(variables), false));
    }
    else {
        if (variables.length)
            throw new Error("Wrong input. ".concat(usage));
        //@ts-ignore
        return np.asarray(template);
    }
};
exports.np = np;
// ==============================
//    Define Global before importing any module
// ==============================
var _globals_1 = require("./_globals");
_globals_1.GLOBALS.np = np;
// ==============================
//    Define casting and core before importing any other module
// ==============================
var NDArray_1 = require("./NDArray");
/** @category Main */
np.NDArray = NDArray_1.default;
// ==============================
//  Define core-related functions
// ==============================
var tolist = NDArray_1.default.prototype.modules.jsInterface.tolist;
/** @category Casting and reshaping */
np.tolist = function (template) {
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    return tolist(np.apply(void 0, __spreadArray([template], __read(variables), false)));
};
/** @category Casting and reshaping */
np.fromlist = NDArray_1.default.prototype.modules.jsInterface.fromlist;
/** @category Casting and reshaping */
np.ravel = NDArray_1.default.prototype.modules.basic.ravel;
/** @category Casting and reshaping */
np.reshape = NDArray_1.default.prototype.modules.basic.reshape;
/** @category Casting and reshaping */
np.array = NDArray_1.default.prototype.modules.basic.array;
/** @category Casting and reshaping */
np.asarray = NDArray_1.default.prototype.modules.basic.asarray;
var reduce = NDArray_1.default.prototype.modules.reduce;
/** @category Reducers */
np.sum = reduce.kw_reducers.sum;
/** @category Reducers */
np.product = reduce.kw_reducers.product;
/** @category Reducers */
np.prod = np.product;
/** @category Reducers */
np.any = reduce.kw_reducers.any;
/** @category Reducers */
np.all = reduce.kw_reducers.all;
/** @category Reducers */
np.max = reduce.kw_reducers.max;
/** @category Reducers */
np.min = reduce.kw_reducers.min;
/** @category Reducers */
np.argmax = reduce.kw_reducers.argmax;
/** @category Reducers */
np.argmin = reduce.kw_reducers.argmin;
/** @category Reducers */
np.mean = reduce.kw_reducers.mean;
/** @category Reducers */
np.norm = reduce.kw_reducers.norm;
/** @category Reducers */
np.var = reduce.kw_reducers.var;
/** @category Reducers */
np.std = reduce.kw_reducers.std;
var transform = NDArray_1.default.prototype.modules.transform;
/** @category Transformations */
np.transpose = transform.transpose;
/** @category Transformations */
np.apply_along_axis = transform.apply_along_axis;
/** @category Transformations */
np.sort = transform.kw_exported.sort;
/** @category Transformations */
np.concatenate = transform.concatenate;
/** @category Transformations */
np.stack = transform.stack;
var kwargs_1 = require("./array/kwargs");
var operators = NDArray_1.default.prototype.modules.operators;
/** @category Binary operators */
np.add = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["+"]);
/** @category Binary operators */
np.subtract = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["-"]);
/** @category Binary operators */
np.multiply = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["*"]);
/** @category Binary operators */
np.divide = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["/"]);
/** @category Binary operators */
np.mod = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["%"]);
/** @category Binary operators */
np.divide_int = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["//"]);
/** @category Binary operators */
np.pow = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["**"]);
/** @category Binary operators */
np.bitwise_or = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["|"]);
/** @category Binary operators */
np.bitwise_and = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["&"]);
/** @category Binary operators */
np.bitwise_xor = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["^"]);
/** @category Binary operators */
np.bitwise_shift_left = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["<<"]);
/** @category Binary operators */
np.bitwise_shift_right = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary[">>"]);
/** @category Binary operators */
np.greater = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary[">"]);
/** @category Binary operators */
np.less = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["<"]);
/** @category Binary operators */
np.greater_equal = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary[">="]);
/** @category Binary operators */
np.less_equal = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["<="]);
/** @category Binary operators */
np.equal = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["=="]);
/** @category Binary operators */
np.not_equal = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["!="]);
/** @category Binary operators */
np.maximum = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["max"]);
/** @category Binary operators */
np.minimum = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["min"]);
/** @category Binary operators */
np.logical_or = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["or"]);
/** @category Binary operators */
np.logical_and = kwargs_1.Func_a_other_out.defaultDecorator(operators.op_binary["and"]);
np.atan2 = operators.atan2;
np.assign = operators.op_assign['='];
np.allclose = operators.allclose;
np.isclose = operators.isclose;
var ew = NDArray_1.default.prototype.modules.elementwise;
/** @category Elementwise operators */
np.sign = ew.kw_funcs.sign;
/** @category Elementwise operators */
np.sqrt = ew.kw_funcs.sqrt;
/** @category Elementwise operators */
np.square = ew.kw_funcs.square;
/** @category Elementwise operators */
np.exp = ew.kw_funcs.exp;
/** @category Elementwise operators */
np.log = ew.kw_funcs.log;
/** @category Elementwise operators */
np.log2 = ew.kw_funcs.log2;
/** @category Elementwise operators */
np.log10 = ew.kw_funcs.log10;
/** @category Elementwise operators */
np.log1p = ew.kw_funcs.log1p;
/** @category Elementwise operators */
np.sin = ew.kw_funcs.sin;
/** @category Elementwise operators */
np.cos = ew.kw_funcs.cos;
/** @category Elementwise operators */
np.tan = ew.kw_funcs.tan;
/** @category Elementwise operators */
np.asin = ew.kw_funcs.asin;
/** @category Elementwise operators */
np.acos = ew.kw_funcs.acos;
/** @category Elementwise operators */
np.atan = ew.kw_funcs.atan;
/** @category Elementwise operators */
np.cosh = ew.kw_funcs.cosh;
/** @category Elementwise operators */
np.sinh = ew.kw_funcs.sinh;
/** @category Elementwise operators */
np.tanh = ew.kw_funcs.tanh;
/** @category Elementwise operators */
np.acosh = ew.kw_funcs.acosh;
/** @category Elementwise operators */
np.asinh = ew.kw_funcs.asinh;
/** @category Elementwise operators */
np.atanh = ew.kw_funcs.atanh;
/** @category Elementwise operators */
np.floor = ew.kw_funcs.floor;
/** @category Elementwise operators */
np.ceil = ew.kw_funcs.ceil;
/** @category Elementwise operators */
np.isnan = ew.kw_funcs.isnan;
/** @category Elementwise operators */
np.isfinite = ew.kw_funcs.isfinite;
/** @category Elementwise operators */
np.abs = ew.kw_funcs.abs;
/** @category Elementwise operators */
np.bitwise_not = ew.kw_funcs.bitwise_not;
/** @category Elementwise operators */
np.logical_not = ew.kw_funcs.logical_not;
/** @category Elementwise operators */
np.negative = ew.kw_funcs.negative;
/** @category Elementwise operators */
np.round = ew.kw_funcs.round;
// ==============================
//   import np modules
// ============================== 
var modules_1 = require("./modules");
/** @category Main @namespace*/
np.modules = modules_1.modules;
/** @category Modules */
np.random = np.modules.random;
/** @category Constructors */
np.empty = np.modules.constructors.empty;
/** @category Constructors */
np.zeros = np.modules.constructors.zeros;
/** @category Constructors */
np.ones = np.modules.constructors.ones;
/** @category Constructors */
np.arange = np.modules.constructors.arange;
/** @category Constructors */
np.linspace = np.modules.constructors.linspace;
/** @category Constructors */
np.geomspace = np.modules.constructors.geomspace;
np.take = np.modules.indexing.take;
np.where = np.modules.indexing.where;
np.nonzero = np.modules.indexing.nonzero;
np.quantile = np.modules.statistics.kw_exported.quantile;
np.nanquantile = np.modules.statistics.kw_exported.nanquantile;
// np.percentile = np.modules.statistics.kw_exported.percentile;
// np.median = np.modules.statistics.kw_exported.median;
// np.average = np.modules.statistics.kw_exported.average;
/** @category Math constants */
np.pi = Math.PI;
/** @category Math constants */
np.e = Math.E;
